export const ThreadsIcon = ({ size = '16', className = '', white = false }) => {
  return (
    <img
      src={`/static/img/icons/threads-logo-${white ? 'white' : 'black'}.svg`}
      style={{ width: `${size}px`, height: `${size}px` }}
      className={className}
      alt="Threads Logo"
    />
  )
}

export default ThreadsIcon
